// Module
var code = "<template> <require from=\"app/core/components/notes/notes-grid\"></require> <notes-grid cache-key=\"UM_AUTH_NOTES_CACHE\" target-id.bind=\"authId\" notes-config.bind=\"notesConfig\" can-edit-notes=\"true\" include-inactive.bind=\"false\" show-inactive-toggle.bind=\"true\" view-model.ref=\"$notesGrid\"></notes-grid> </template> ";
// Exports
module.exports = code;